import React from "react";

class Inline extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bold: false,
            italic: false,
            strikethrough: false
        }
    }

    render() {
        const onChange = ( key ) => {
            this.setState({
                ...this.state,
                [key]: this.state[key] ? false : true
            }, () => {
                this.props.onChange( key, this.state[key] );
            })
        }

        return (
            <div class="toolbar-buttons">
                <ul>
                    <li>
                        <a onClick={ () => onChange('bold') } class={ this.props.currentState.bold ? "active" : "" }>
                            <i class="material-icons">format_bold</i>
                        </a>
                    </li>
                    <li>
                        <a onClick={ () => onChange('italic') } class={ this.props.currentState.italic ? "active" : "" }>
                            <i class="material-icons">format_italic</i>
                        </a>
                    </li>
                    <li>
                        <a onClick={ () => onChange('strikethrough') } class={ this.props.currentState.strikethrough ? "active" : "" }>
                            <i class="material-icons">format_strikethrough</i>
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}

export default Inline;